import React from "react";
import { Box, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
// import PageHeading from "../components/layouts/PageHeading";
import ProgressBarITE from "./nav/ProgressBarITE";
// import ClientAudit from "../components/forms/ClientAudit";
import MultiStepForm2ITE from "../../components/formsITE/MultiStepForm2ITE";

const formSections = [
  "Renseignements du client",
  "Bilan Énergétique",
  "Économies Énergétique",
];

const PartTwoITE = () => {
  const navigate = useNavigate();
  const currentSection = 1; // Index of the current section for the progress bar

  const handleFormSubmit = () => {
    navigate("/client-economies-ite"); // Assuming you have a route set up for the second part
    window.scrollTo(0, 0);
  };

  return (
    <Box width="full">
      <Box position="sticky" h={"140px"} top={0} bg="white" zIndex={1}>
        <ProgressBarITE sections={formSections} currentSection={currentSection} />
      </Box>
      <MultiStepForm2ITE onSubmit={handleFormSubmit} />
    </Box>
  );
};

export default PartTwoITE;
